<details class="answer-legend">
  <summary class="answer-legend-summary">{{ 'answerLegendTitle' | translate }}</summary>
  <ul class="answer-legend-list">
    <li><span class="legend-symbol legend-correct" aria-hidden="true">&#x2713;</span>{{ 'answerLegendCorrect' | translate }}</li>
    <li><span class="legend-symbol legend-wrong" aria-hidden="true">&#x2717;</span>{{ 'answerLegendWrong' | translate }}</li>
  </ul>
  <p class="answer-legend-note">{{ 'answerLegendSelection' | translate }}</p>
</details>
